// The ACTIVE organization — a plain module holder so the axios interceptor and the mock gateway can
// read it WITHOUT importing the Zustand store (avoids a store↔gateway import cycle) exactly like
// lib/authToken holds the access token.

const KEY = "sm_active_org";

let activeOrgId: string | null = (() => {
  try {
    return localStorage.getItem(KEY);
  } catch {
    return null;
  }
})();

export function getActiveOrg(): string | null {
  return activeOrgId;
}

export function setActiveOrgId(id: string | null): void {
  activeOrgId = id;
  try {
    if (id) localStorage.setItem(KEY, id);
    else localStorage.removeItem(KEY);
  } catch {
    /* private mode — the in-memory value still drives requests this session */
  }
}
